import { initializeApp } from "./app.js"
import { setupLoopDelayUi } from "./loop-delay-ui.js"
import { setupCropMetrics } from "./crop-metrics.js"
import { setupSmoothLoopUi } from "./smooth-loop-ui.js"
import { setupStabilizerUi } from "./stabilizer-ui.js"
import { setupEffectsUi } from "./effects-ui.js"

document.documentElement.dataset.sourceLayout = "stable"
initializeApp()
setupLoopDelayUi()
setupCropMetrics()
setupSmoothLoopUi()
setupStabilizerUi()
setupEffectsUi()
